//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.PreviewData
import com.tixforgigs.apax.models.TemplateConfigType
import com.tixforgigs.apax.models.TemplateData
import com.tixforgigs.apax.models.TemplateFilter
import com.tixforgigs.apax.models.ThemeData

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template config model
* 
* @param configType 
* @param lastModifiedDate The last modified date.
* @param previewData 
* @param templateData 
* @param templateName The template name
* @param configId The config id.
* @param filter 
* @param locale ...
* @param themeData 
*/
@Serializable

data class TemplateConfigItem (


      @SerialName(value = "configType") @Required val configType: TemplateConfigType,


      /* The last modified date. */
    @SerialName(value = "lastModifiedDate") @Required val lastModifiedDate: kotlin.time.Instant,


      @SerialName(value = "previewData") @Required val previewData: PreviewData,


      @SerialName(value = "templateData") @Required val templateData: TemplateData,


      /* The template name */
    @SerialName(value = "templateName") @Required val templateName: kotlin.String,


      /* The config id. */
    @SerialName(value = "configId") val configId: kotlin.uuid.Uuid? = null,


      @SerialName(value = "filter") val filter: TemplateFilter? = null,


      /* ... */
    @SerialName(value = "locale") val locale: kotlin.String? = null,


      @SerialName(value = "themeData") val themeData: ThemeData? = null


) {




  }

